// @ts-nocheck
/**
 * mountedHook.ts
 * App.vue onMounted() の本体
 * App.vue から切り出し
 */
import { setupAuthStateListener } from '@/js/authSetup'
import { capture, fitClickCircleAll, restorePhotoMemoPathArrows } from '@/js/downLoad'
import pyramid from '@/js/pyramid'
import * as turf from '@turf/turf'
import { snapIfNeeded } from '@/js/utils/triangle50'
import axios from 'axios'
import { VPS_API_BASE } from '@/js/phpApi'
import { checkStripeRedirect, verifyCheckoutSession } from '@/js/stripeService'
import { loadSessionState } from '@/js/sessionState'

type VM = any

export function onMounted(vm: VM) {
// インラインスプラッシュを除去（index.htmlで白画面防止用に表示していたもの）
const inlineSplash = document.getElementById('inline-splash')
if (inlineSplash) inlineSplash.remove()

// PWA/ブラウザタブにバージョンを表示
document.title = `OH3 v${vm.$store.state.clientVersion}`

// Vueインスタンスをグローバルに登録（draw.jsから参照するため）
window.vueApp = vm;
// storeにもAppインスタンスを登録（draw.jsから参照するため）
vm.$store.state.oh3App = vm;

// ページビューイベントを記録（DAU計測用）
vm.usageTracker?.trackEvent('page', 'view', 'app-load', {
  referrer: document.referrer || 'direct',
  url: window.location.href
});

// 価格推移表ボタンのクリックイベントリスナー
document.addEventListener('click', (e) => {
  if (e.target.classList.contains('oh-price-history-btn')) {
    const lat = parseFloat(e.target.dataset.lat)
    const lng = parseFloat(e.target.dataset.lng)
    const type = e.target.dataset.type || 'koji'
    const location = e.target.dataset.location || ''
    const lotNumber = e.target.dataset.lotNumber || ''
    vm.openPriceHistoryWindow({ lat, lng, type, location, lotNumber })
  }
  // AI物件調査レポートボタン（地価公示/地価調査ポップアップから）
  if (e.target.classList.contains('oh-ai-point-info-btn') || e.target.classList.contains('oh-property-report-btn')) {
    const lat = parseFloat(e.target.dataset.lat)
    const lng = parseFloat(e.target.dataset.lng)
    // トラッキング
    vm.usageTracker?.trackEvent('popup', 'click', 'ai-propertyReport', { source: 'price-popup' })
    // マルチインスタンスFWを追加（座標を渡してデータ取得開始）
    vm.$store.commit('addFWInstance', {
      type: 'property-report',
      data: { lng, lat }
    })
  }
})

// 免責表示を5秒後にフェードイン
setTimeout(() => {
  vm.showDisclaimer = true
}, 5000)

// 桜エフェクトはスプラッシュ（ロゴ）が消えた後に開始（App.vue onSplashFinish）
// スプラッシュ非表示設定の場合のフォールバック
if (!vm.$store.state.isSplash) {
  setTimeout(() => { vm.$store.state.showSakuraEffect = true }, 1000)
}

// isSmall500 のときは自動で現在地にパン（マーカーなし）
// ※ 一時的に無効化（2025-02）
// const isSmallScreen = vm.isSmall500 || window.innerWidth < 500
// if (isSmallScreen) {
//   vm.waitForMap('map01', { loaded: true }).then(() => {
//     if ('geolocation' in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const map = vm.$store.state.map01
//           if (!map) return
//           map.flyTo({
//             center: [position.coords.longitude, position.coords.latitude],
//             zoom: 15.01,
//             essential: true
//           })
//         },
//         (err) => console.warn('[App] 現在地取得失敗:', err),
//         { enableHighAccuracy: true, maximumAge: 0, timeout: 15000 }
//       )
//     }
//   }).catch(err => {
//     console.warn('[App] waitForMap failed:', err)
//   })
// }

// 印刷タイトルの高さを初期化
vm.updatePrintTitleHeight();

// Firebase認証状態の初期化を待つ
setupAuthStateListener(vm)

// 新規登録促進ダイアログの表示状態をlocalStorageから読み込む
const hidePromo = localStorage.getItem('oh3.hideSignUpPromo')
if (hidePromo === '1') {
  vm.showSignUpPromoDialog = false
}

// 初期値設定
Object.assign(vm.$store.state,{isSmall1000:window.innerWidth<1000,isSmall500:window.innerWidth<500})
// リサイズ監視
window.addEventListener('resize',()=>{
  Object.assign(vm.$store.state,{isSmall1000:window.innerWidth<1000,isSmall500:window.innerWidth<500});
},{passive:true})

// PC状態で表示の初期値をbodyクラスに反映
if (vm.$store.state.showPcMode) {
  document.body.classList.add('show-pc-mode')
}

// android対応まとめ-----------------------------------------------------------
if (vm.s_isAndroid) {
  vm.stopOnMenu = (e) => {
    // v-selectのドロップダウンメニューも含める
    const content = e.target.closest('.v-overlay__content.scrollable-menu, .v-overlay__content .v-list, .v-select-list, .v-overlay__content');
    if (content) e.stopPropagation();   // ← スクロールはネイティブに任せる
  };
  // 伝播を止めるには capture: true で早期にフック
  window.addEventListener('touchstart', vm.stopOnMenu, { capture: true, passive: true });
  window.addEventListener('touchmove',  vm.stopOnMenu, { capture: true, passive: true });
  window.addEventListener('touchend',   vm.stopOnMenu, { capture: true, passive: true });
}

if (vm.s_isAndroid) {
  const contentSelector = '.fw-fit'; // スクロールさせたい要素
  vm.stopOnContent = (e) => {
    // オーバーレイ内の操作は外へ伝播させない（外側パン/ズームを無効化）
    const target = e.target.closest(contentSelector);
    if (target) {
      // ここでは preventDefault は原則しない（ネイティブの慣性を殺さない）
      e.stopPropagation();
    }
  };

  // キャプチャは使うが、対象が content の時だけ止める
  window.addEventListener('touchstart', vm.stopOnContent, { capture: true, passive: true });
  window.addEventListener('touchmove',  vm.stopOnContent, { capture: true, passive: true });
  window.addEventListener('touchend',   vm.stopOnContent, { capture: true, passive: true });
}

// if (vm.s_isAndroid){
//   let startY;
//   let isTouching = false;
//   let currentTarget = null;
//   let initialScrollTop = 0;
//   document.addEventListener('touchstart', (e) => {
//     const target = e.target.closest('.fw-fit');
//     if (target) {
//       startY = e.touches[0].clientY; // タッチ開始位置を記録
//       initialScrollTop = target.scrollTop; // 初期スクロール位置を記録
//       isTouching = true;
//       currentTarget = target;
//       target.style.overflowY = 'auto'; // スクロールを強制的に有効化
//       target.style.touchAction = 'manipulation';
//       // **イベント伝播を防ぐ**
//       e.stopPropagation();
//     }
//   }, { passive: true, capture: true });
//
//   // タッチ移動時の処理
//   document.addEventListener('touchmove', (e) => {
//     if (!isTouching || !currentTarget) return; // タッチが開始されていなければ処理しない
//     const moveY = e.touches[0].clientY;
//     const deltaY = startY - moveY; // 移動量を計算
//     // スクロール位置を更新
//     currentTarget.scrollTop += deltaY;
//     startY = moveY; // 開始位置を現在の位置に更新
//     // **Android でスクロールが無視されないようにする**
//     e.preventDefault();
//     e.stopPropagation();
//
//   }, { passive: true, capture: true });
//
//   // タッチ終了時の処理
//   document.addEventListener('touchend', () => {
//     if (currentTarget) {
//       currentTarget.style.overflowY = ''; // スクロール設定をリセット
//     }
//     currentTarget = null; // 現在のターゲットをリセット
//     isTouching = false; // タッチ中フラグをOFF
//     initialScrollTop = 0; // 初期スクロール位置をリセット
//   });
// }
// android対応まとめ-----------------------------------------------------------



// ---- GPSライン描画 用の状態 ----
vm.gpsLineIds = vm.gpsLineIds ?? {
  src:       'oh-gps-line-src',
  layer:     'oh-gps-line',
  labelSrc:  'oh-gps-line-label-src',
  labelLayer:'oh-gps-line-label'
};
vm.onMapClickForGpsLine = vm.onMapClickForGpsLine ?? null;

// Turf / snap の安全な参照
vm._turf = vm._turf ?? (typeof turf !== 'undefined' ? turf : (window && window.turf));
vm._snapIfNeeded = vm._snapIfNeeded ?? (typeof snapIfNeeded === 'function' ? snapIfNeeded : (window && window.snapIfNeeded));

// 距離の表示フォーマット
vm.formatDist = vm.formatDist ?? function (meters) {
  if (meters < 1000) return `${meters.toFixed(1)} m`;
  return `${(meters/1000).toFixed(3)} km`;
};

// クリック許可フラグ（現在地トラッキング中のみtrue）
vm.enableGpsLineClick = vm.enableGpsLineClick ?? false;


if (vm.$store.state.isDrawFit) {
  vm.waitForMap('map01', { loaded: true })
      .then(map => {
        // 非同期ロード対策で軽くリトライ
        const tryFit = (n = 6) => fitClickCircleAll() || (n > 0 && setTimeout(() => tryFit(n - 1), 500));
        tryFit();
      })
      .catch(console.warn);
}

window.addEventListener('mousemove', vm.onMouseMove)

vm.mapillarWidth = (window.innerWidth * 1) + 'px'
vm.mapillarHeight = (window.innerHeight * 1) + 'px'

window.addEventListener('keydown', vm.onKeydown);

// 5分おきに実行
vm.intervalId = setInterval(() => {
  if (window.location.href !== vm.preUrl) {
    capture(vm.uid,false)
    vm.historyCount++
  }
  vm.preUrl = window.location.href
}, 5 * 60 * 1000)
// -----------------------------------------------------------------------------

// iOS対策: バックグラウンドに行った時にタイマーを一時停止
vm.handleVisibilityChange = () => {
  if (document.visibilityState === 'hidden') {
    // バックグラウンドに行った時：全てのタイマーを一時停止

    // 位置情報ポーリングを一時停止
    if (vm.geoPollTimer) {
      clearInterval(vm.geoPollTimer);
      vm.geoPollTimer = null;
      vm._geoPollingWasActive = true; // 再開フラグ
    }

    // メモリクリーンアップを一時停止
    if (vm.memoryCleanupInterval) {
      clearInterval(vm.memoryCleanupInterval);
      vm.memoryCleanupInterval = null;
      vm._memoryCleanupWasActive = true; // 再開フラグ
    }

    // 履歴記録タイマーを一時停止
    if (vm.intervalId) {
      clearInterval(vm.intervalId);
      vm.intervalId = null;
      vm._historyIntervalWasActive = true; // 再開フラグ
    }

    // スケール/角度調整のインターバルを停止
    try { vm.stopScaleUp(); } catch(_) {}
    try { vm.stopScaleDown(); } catch(_) {}
    try { vm.stopAnglePlus(); } catch(_) {}
    try { vm.stopAngleMinus(); } catch(_) {}

  } else if (document.visibilityState === 'visible') {
    // フォアグラウンドに戻った時：必要なタイマーを再開

    // 位置情報ポーリングを再開（追跡中だった場合のみ）
    if (vm._geoPollingWasActive && (vm.isTracking || vm.s_isKuiuchi)) {
      vm._geoPollingWasActive = false;
      // startWatchPositionを呼び直す
      try { vm.startWatchPosition(); } catch(_) {}
    }

    // メモリクリーンアップを再開
    if (vm._memoryCleanupWasActive && vm.$store.state.isIphone) {
      vm._memoryCleanupWasActive = false;
      vm.memoryCleanupInterval = setInterval(() => {
        const map = vm.$store.state.map01;
        if (map && map.isStyleLoaded && map.isStyleLoaded()) {
          try {
            map.querySourceFeatures && map.querySourceFeatures();
          } catch (_) {}
        }
      }, 60000);
    }

    // 履歴記録タイマーを再開
    if (vm._historyIntervalWasActive) {
      vm._historyIntervalWasActive = false;
      vm.intervalId = setInterval(() => {
        if (window.location.href !== vm.preUrl) {
          capture(vm.uid, false);
          vm.historyCount++;
        }
        vm.preUrl = window.location.href;
      }, 5 * 60 * 1000);
    }
  }
};
document.addEventListener('visibilitychange', vm.handleVisibilityChange);

window.addEventListener("resize", vm.onResize);

if (window.innerWidth < 500) {
  vm.s_isSmartPhone = true
  vm.terrainBtnClos()
}

// -----------------------------------------------------------------------------------------------------------------
vm.mapNames.forEach(mapName => {
  const myDiv = document.getElementById("terrain-btn-div-" + mapName)
  let startY = 0;      // マウスまたはタッチの初期Y座標
  let startX = 0;      // マウスまたはタッチの初期X座標
  let startBottom = 0; // divの初期bottom位置
  let startRight = 0;  // divの初期right位置
  let isDragging = false;

  // ドラッグ開始（マウスまたはタッチ）
  function startDrag(e) {
    isDragging = true;
    const clientX = e.clientX || e.touches[0].clientX;
    const clientY = e.clientY || e.touches[0].clientY;
    startY = clientY;
    startX = clientX;
    startBottom = parseInt(window.getComputedStyle(myDiv).bottom, 10);
    startRight = parseInt(window.getComputedStyle(myDiv).right, 10);
    myDiv.style.cursor = "grabbing";
    e.preventDefault(); // タッチ時のスクロール防止
  }

  // ドラッグ中（マウスまたはタッチ）
  function drag(e) {
    if (isDragging) {
      const clientX = e.clientX || e.touches[0].clientX;
      const clientY = e.clientY || e.touches[0].clientY;
      const deltaY = startY - clientY;
      const deltaX = startX - clientX;
      myDiv.style.bottom = `${startBottom + deltaY}px`;
      myDiv.style.right = `${startRight + deltaX}px`;
    }
  }

  // ドラッグ終了（マウスまたはタッチ）
  function endDrag() {
    isDragging = false;
    myDiv.style.cursor = "grab";
  }

  // イベントリスナーの追加（マウスとタッチの両方に対応）
  myDiv.addEventListener("mousedown", startDrag);
  document.addEventListener("mousemove", drag);
  document.addEventListener("mouseup", endDrag);

  myDiv.addEventListener("touchstart", startDrag, { passive: false });
  document.addEventListener("touchmove", drag, { passive: false });
  document.addEventListener("touchend", endDrag, { passive: true });
})
// -----------------------------------------------------------------------------------------------------------------
pyramid()
//------------------------------------------------------------------------------------------------------------------
document.addEventListener('touchmove', function (event) {
  if (event.scale !== 1) {
    event.preventDefault();
  }
}, { passive: false });
//------------------------------------------------------------------------------------------------------------------
// Stripe Checkoutリダイクト後の処理
const stripeRedirect = checkStripeRedirect()
if (stripeRedirect.sessionId) {
  // 非同期でセッション検証（UIをブロックしない）
  verifyCheckoutSession(stripeRedirect.sessionId).then(result => {
    if (result.success) {
      const planNames: Record<string, string> = { personal: 'Personal', pro: 'Pro', office: '事務所', office_pro: '事務所Pro', unlimited: '無制限', business: '事務所プラン' }
      vm.snackbarText = `${planNames[result.plan_type] || result.plan_type} プランが有効になりました`
      vm.snackbar = true
    } else {
      console.warn('[Stripe] セッション検証失敗:', result.error)
    }
  }).catch(err => {
    console.error('[Stripe] verifyCheckoutSession error:', err)
  })
} else if (stripeRedirect.result === 'cancel') {
}

const params = new URLSearchParams(window.location.search)
const sParam = params.get('s')
const ssParam = params.get('ss')
if (!vm.$store.state.isOffline && ssParam === '1') {
  // === Flow 1: session_stateから復元 (?ss=1) ===
  const lastUid = localStorage.getItem('lastUserId')
  if (lastUid) {
    loadSessionState(lastUid).then(savedParams => {
      if (savedParams) {
        vm.dbparams = savedParams
      }
      vm.init()
    }).catch(() => {
      vm.init()
    })
  } else {
    vm.init()
  }
} else if (!vm.$store.state.isOffline && sParam) {
  // === Flow 2: shorturlから復元 (?s=XXXXXXX) ===
  const additionalParams = new URLSearchParams()
  for (const [key, value] of params.entries()) {
    if (key !== 's') {
      additionalParams.append(key, value)
    }
  }
  axios.get(`${VPS_API_BASE}/shortUrlSelect.php`, {
    params: { urlid: sParam }
  }).then(function (response) {
    let mergedParams = response.data
    if (additionalParams.toString()) {
      mergedParams = mergedParams
        ? `${mergedParams}&${additionalParams.toString()}`
        : additionalParams.toString()
    }
    vm.dbparams = mergedParams
    vm.init()
    const url = new URL(window.location.href)
    window.history.replaceState(null, '', url.pathname + window.location.hash)
  })
} else {
  vm.init()
}
if (localStorage.getItem('resolution')) {
  vm.s_resolution = localStorage.getItem('resolution')
  if (vm.s_resolution > 24) vm.s_resolution = 24
}

// 初回起動ウィザードのチェック（開発環境では常に表示、本番では未完了時のみ）
vm.$nextTick(() => {
  vm.$store.dispatch('checkAndShowWizard')
})

// オンボーディングのチェック（初回訪問時のみ）
// vm.$nextTick(() => {
//   vm.checkAndStartOnboarding()
// })

// 写真メモ行動軌跡の矢印を遅延復元（全マップ初期化完了後）
setTimeout(() => {
  const map = vm.$store.state.map01
  const geojsonText = vm.$store.state.clickCircleGeojsonText
  if (map && geojsonText) {
    try {
      const geojson = JSON.parse(geojsonText)
      restorePhotoMemoPathArrows(map, geojson)
    } catch (err) {
      console.warn('[mounted] Failed to restore photo memo path arrows:', err)
    }
  }
}, 3000) // 3秒後に復元（全マップの初期化完了を待つ）
}
